import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { Toaster } from "sonner";

import App from "./App.tsx";
import { Icon } from "./components/ui/icon.tsx";
import { loadConfig } from "./lib/config/env.ts";
import { initializePusher } from "./lib/pusher.ts";
import store from "./redux/store.ts";
// If using solution 3
import "./styles/global.css";

async function initializeApp() {
  try {
    // NOTE: This monkey-patches console.error to suppress React 18.3+ "defaultProps" deprecation
    // warnings specifically thrown by older, unmaintained third-party packages like `react-color`.
    // Once those packages are replaced or updated, this block can be safely removed.
    const originalConsoleError = console.error;
    console.error = (...args: any[]) => {
      if (
        typeof args[0] === "string" &&
        args[0].includes(
          "Support for defaultProps will be removed from function components",
        )
      ) {
        return;
      }
      originalConsoleError(...args);
    };

    // Load runtime configuration first
    await loadConfig();

    // Initialize Pusher after config is loaded (if using solution 3)
    await initializePusher();

    ReactDOM.createRoot(document.getElementById("root")!).render(
      <Provider store={store}>
        <App />
        <Toaster
          closeButton
          position="top-center"
          icons={{
            success: <Icon name="CircleCheck" className="text-success-500" />,
            info: <Icon name="Info" className="text-info-500" />,
            warning: <Icon name="ShieldAlert" className="text-warning-500" />,
            error: <Icon name="CircleAlert" className="text-danger-500" />,
          }}
          toastOptions={{
            classNames: {
              toast: "w-full max-w-64 rounded-2xl flex justify-center",
            },
          }}
        />
      </Provider>,
    );
  } catch (error) {
    console.error("Failed to initialize app:", error);
    // You might want to show a fallback UI here
  }
}

initializeApp();
